import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.algorithm.run');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
@Component({
    selector: 'wiz-page-algorithm-run',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.algorithm.run/view.scss */
:host {
  display: block;
  height: 100%;
}

main {
  width: 100%;
  max-width: none;
  min-height: 100%;
  margin: 0;
  padding: clamp(24px, 4vw, 52px);
  color: #37352f;
  background: #fff;
}

h1 {
  font-size: 32px;
  font-weight: 700;
  margin: 20px 0 8px;
}

h2 {
  font-size: 20px;
  font-weight: 650;
  margin: 0 0 14px;
}

p {
  font-size: 14px;
  line-height: 1.8;
}

a {
  color: #62836f;
  font-size: 13px;
}

.subtitle, .caption {
  color: #8b8e87;
}

.caption {
  font-size: 12px;
}

.notice {
  padding: 18px;
  background: #f2f5f1;
  border-radius: 0;
  margin: 22px 0;
}

.controls {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: #ddd;
}

label {
  font-size: 12px;
  color: #777;
  background: #fff;
  padding: 14px;
}

input:not(.scrubber), select {
  display: block;
  width: 100%;
  margin-top: 7px;
  padding: 9px;
  border: 1px solid #ddd;
  border-radius: 0;
  background: white;
}

button {
  padding: 9px 14px;
  border: 1px solid #ddd;
  border-radius: 0;
  font-size: 13px;
  background: white;
}

button.primary {
  background: #62836f;
  color: white;
  border-color: #62836f;
}

button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.actions, .section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0;
  flex-wrap: wrap;
}

.section-head {
  justify-content: space-between;
}

.section-head select {
  width: auto;
}

.status {
  color: #62836f;
}

section {
  margin-top: 30px;
}

.scene, .chart {
  width: 100%;
  max-height: none;
  border: 1px solid #eee;
  border-radius: 0;
}

svg text {
  font-size: 11px;
  fill: #888;
}

.scrubber {
  width: 100%;
}

.table-scroll {
  overflow: auto;
}

table {
  width: 100%;
  font-size: 12px;
  border-collapse: collapse;
  white-space: nowrap;
}

td, th {
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

th {
  background: #f6f6f3;
}

.legend {
  display: flex;
  gap: 20px;
  font-size: 12px;
}

button:focus-visible, a:focus-visible {
  outline: 2px solid #62836f;
  outline-offset: 3px;
}

@media (max-width: 700px) {
  main {
    padding: 22px;
  }
  .controls {
    grid-template-columns: 1fr 1fr;
  }
}`],
})
export class PageAlgorithmRunComponent implements OnInit, OnDestroy {
    @Input() embedded = false;
    public n=20; public seed=42; public safety=.3; public pattern='cross';
    public busy=false; public message='조건을 설정하고 실험을 실행하세요.';
    public results:any[]=[]; public selected:any=null; public frame=0; public timer:any=null;
    public metric='perStep'; public measured:any=null;
    public metrics=[{key:'perStep',name:'스텝당 Runtime (ms)'},{key:'runtime',name:'누적 Runtime (ms)'},{key:'time',name:'도달 시간 (s)'},{key:'distance',name:'이동 거리 (m)'},{key:'collisions',name:'충돌 횟수'},{key:'violations',name:'안전거리 위반 횟수'},{key:'success',name:'성공 여부 (1/0)'},{key:'checks',name:'이웃/제약 검사 횟수'}];
    constructor(@Inject(Service) public service:Service) {}
    public async ngOnInit(){ await this.service.init(); await this.service.render(); }
    public ngOnDestroy(){ this.stop(); }
    public stop(){ if(this.timer) clearInterval(this.timer); this.timer=null; }
    public async run(mode:string){
        this.stop(); this.busy=true; this.message='동일한 시드와 조건으로 세 방식을 계산 중입니다.';
        await this.service.render();
        try {
            const response=await wiz.call('run',{n:this.n,seed:this.seed,safety:this.safety,pattern:this.pattern,mode});
            if(response.code!==200) throw new Error(response.message || response.data?.message || '실험 요청 실패');
            this.measured={n:this.n,seed:this.seed,safety:this.safety,pattern:this.pattern}; this.results=response.data; this.selected=this.results.find(r=>r.frames.length) || null; this.frame=0;
            this.message='측정 완료 · 시드 '+this.seed+' · 안전 여유 '+this.safety+'m · '+(this.pattern==='cross'?'수직 교차':'임의 방향')+' · 규모당 1회 실험';
        } catch(e){ this.message=e.message || '실험 요청에 실패했습니다.'; }
        finally { this.busy=false; await this.service.render(); }
    }
    public async select(row:any){ this.stop(); this.selected=row.frames.length?row:null; this.frame=0; await this.service.render(); }
    public async play(){
        if(this.timer){this.stop();await this.service.render();return;}
        if(!this.selected) return;
        if(this.frame>=this.selected.frames.length-1)this.frame=0;
        this.timer=setInterval(async()=>{this.frame++;if(this.frame>=this.selected.frames.length-1)this.stop();await this.service.render();},100);
        await this.service.render();
    }
    public get current(){return this.selected?.frames[this.frame];}
    public get path(){return this.selected?.frames.slice(0,this.frame+1).map(f=>(f.robot[0]*30)+','+(360-f.robot[1]*30)).join(' ') || '';}
    public get maxValue(){ return Math.max(1,...this.results.map(r=>Number(r[this.metric])||0));}
    public get maxN(){return Math.max(1,...this.results.map(r=>r.n));}
    public color(method:string){return {Naive:'#d39152',VO:'#537fc1',ORCA:'#668b75'}[method];}
    public points(method:string){return this.results.filter(r=>r.method===method && r[this.metric]!==null).map(r=>(45+r.n/this.maxN*490)+','+(210-Number(r[this.metric])/this.maxValue*170)).join(' ');}
    public async render(){await this.service.render();}
    public download(){this.service.file.download({conditions:this.measured,results:this.results.map(({frames,...r})=>r)},'newton-results.json');}
}

export default PageAlgorithmRunComponent;